import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
import { HIDE_LAKE_ADD_TO_INVESTIGATION_HELP_TEXT_KEY } from "data-lake/Constants";
import Store from "logic/local-storage/Store";
import useSelectedEntities from "components/common/EntityDataTable/hooks/useSelectedEntities";
const AddToInvestigationHelp = () => {
  var _a;
  const { t } = useTranslation("enterprise_data_lake");
  const { selectedEntities } = useSelectedEntities();
  const [hideHelpText, setHideHelpText] = useState(Store.get(HIDE_LAKE_ADD_TO_INVESTIGATION_HELP_TEXT_KEY) === "true");
  const hideHelp = () => {
    Store.set(HIDE_LAKE_ADD_TO_INVESTIGATION_HELP_TEXT_KEY, "true");
    setHideHelpText(true);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("add_to_investigation.retrieve_count", { count: (_a = selectedEntities == null ? void 0 : selectedEntities.length) != null ? _a : 0 })), !hideHelpText && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info", onDismiss: hideHelp }, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "add_to_investigation.info", components: { bold: /* @__PURE__ */ React.createElement("b", null) } })));
};
export default AddToInvestigationHelp;
